// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
// import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
// import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";
// import ThumbDownOutlinedIcon from "@material-ui/icons/ThumbDownOutlined";
// import "./AdyaLikeDislikeButton.css";
// import { sendUserLikeDislikeFeedback } from "../../../../services/indianbank_services/adya_feedback_services";
// import { connect } from "react-redux";

// /**
//  * Inline CSS => MUI4
//  * fontSize="large" || fontSize="small"
//  *
//  */

// const useStyles = makeStyles({
//   likeDislikeLabel: {
//     marginLeft: "7px",
//   },
// });

// function AdyaLikeDislikeButton(props) {
//   const classes = useStyles();
//   const [onLike, setonLike] = React.useState(false);
//   const [onDislike, setonDislike] = React.useState(false);
//   const [adyaLikeDislike, setonAdyaLikeDislike] = React.useState(0);
//   const [onClickCounter, setonClickCounter] = React.useState(0);
//   const [resData, setresData] = React.useState();

//   let response_data;
//   let user_query;

//   function sendAdyaQueryFeedback(adya_feedback) {
//     // console.log("adya_feedback: ", adya_feedback);

//     // console.log("props: ", props);
//     // console.log("JSON.stringify(props.message): ", JSON.stringify(props.message));

//     if (JSON.stringify(props.message.herocardData)) {
//       // console.log("herocard data is there: ", JSON.stringify(props.message.herocardData));
//       response_data = JSON.stringify(
//         props.message.herocardData.BODY.details.type
//       );
//       user_query = props.message.herocardData.BODY.details.data.title;
//       // console.log("User Query HEROCARD: ", user_query);
//       setresData(response_data);

//       // console.log("response_data: ", response_data);
//     } else if (JSON.stringify(props.message.workflowData)) {
//       // console.log("workflowData data is there: ", JSON.stringify(props.message.workflowData));
//       response_data = JSON.stringify(props.message.workflowData.BODY.type);
//       user_query = props.message.workflowData.BODY.type;
//       // console.log("User Query WORKFLOW: ", user_query);
//       setresData(response_data);
//       // console.log("response_data: ", response_data);
//     } else if (JSON.stringify(props.message.adyanlpData)) {
//       // console.log("nlp user_query: ", props.message.adyaNlpQuery)
//       // console.log("nlp data: ", JSON.stringify(props.message.adyanlpData.BODY));
//       user_query = props.message.adyaNlpQuery;
//       // console.log("User Query ADYA NLP: ", user_query);
//       response_data = JSON.stringify(props.message.adyanlpData.BODY);
//     }

//     // if(onClickCounter == 0){
//     //   setonClickCounter(1);
//     // } else if(onClickCounter == 1){
//     //   console.log("You already have clicked");
//     // }

//     if (adya_feedback == 1) {
//       setonLike(true);
//       // setonAdyaLikeDislike(adya_feedback);
//     } else if (adya_feedback == -1) {
//       setonDislike(true);
//       // setonAdyaLikeDislike(adya_feedback);
//     }
//   }

//   // function sendResponseData(data){
//   //   console.log("sendResponseData: ", data);

//   // }

//   return (
//     <>
//       <div
//         className="icon-preview col s2 m3"
//         onClick={() => {
//           sendAdyaQueryFeedback(1);
//           setonClickCounter(1);
//           setonAdyaLikeDislike(1);
//           sendUserLikeDislikeFeedback({
//             sessionId: props.sessionDetails.session_id,
//             userLikeDislike: 1,
//             user_query: user_query,
//             response_type: JSON.stringify(props.message.type),
//             user_language: JSON.stringify(props.message.botType.language),
//             response_data: response_data,
//             user_like_dislike_timestamp: `${new Date().toLocaleString("en-GB", {
//               hour12: true,
//             })}`,
//             // user_like_dislike_timestamp: `${new Date().toLocaleString("en-US", {
//             //   hour12: true,
//             // })}`,
//           });
//           // console.log(`Message: ${JSON.stringify(props.message)}`);
//         }}
//       >
//         {/* Thumbs Up Icon adya-like */}

//         {/* If true => Call Colored ThumbsUp Component */}
//         {onLike === true ? (
//           <ThumbUpAltIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         ) : (
//           <ThumbUpOutlinedIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         )}
//       </div>
//       <div
//         className="icon-preview col s2 m3"
//         onClick={() => {
//           sendAdyaQueryFeedback(-1);
//           setonClickCounter(1);
//           setonAdyaLikeDislike(1);
//           sendUserLikeDislikeFeedback({
//             sessionId: props.sessionDetails.session_id,
//             userLikeDislike: -1,
//             user_query: user_query,
//             response_type: JSON.stringify(props.message.type),
//             user_language: JSON.stringify(props.message.botType.language),
//             // response_data: JSON.stringify(props.message),
//             response_data: response_data,
//             user_like_dislike_timestamp: `${new Date().toLocaleString("en-GB", {
//               hour12: true,
//             })}`,
//             // user_like_dislike_timestamp: `${new Date().toLocaleString("en-US", {
//             //   hour12: true,
//             // })}`,
//           });
//           // console.log(`Message: ${JSON.stringify(props.message)}`);
//         }}
//       >
//         {/* Thumbs Down Icon adya-dislike */}
//         {/* <ThumbDownOutlinedIcon style={{ fontSize: 17, cursor: "pointer"}} /> */}

//         {/* If true => Call Colored ThumbsDown Component */}
//         {onDislike === true ? (
//           <ThumbDownAltIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         ) : (
//           <ThumbDownOutlinedIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         )}
//       </div>
//     </>
//   );
// }

// const mapStateToProps = (state) => {
//   return {
//     logInData: state.logInStatus,
//     sessionDetails: state.sessionDetails,
//   };
// };

// export default connect(mapStateToProps)(AdyaLikeDislikeButton);

import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";
import ThumbDownOutlinedIcon from "@material-ui/icons/ThumbDownOutlined";
import { sendUserLikeDislikeFeedback } from "../../../../services/indianbank_services/adya_feedback_services";
import { connect } from "react-redux";

const useStyles = makeStyles({
  likeDislikeContainer: {
    display: "inline-flex",
    alignItems: "center",
    // display:"flex",
    // gap:"5px",
    marginTop: "-45px",
    marginLeft: "70%",
    // justifyContent:"flex-start"
    gap:"1rem"
    

  },
  dislikeButton: {
    marginLeft: "0 !important",
    color:"red",
    padding:"0 !important"
  },
  likeButton:{
    color:"green",
     padding:"0 !important"
  }
});

function AdyaLikeDislikeButton(props) {
  const classes = useStyles();
  const [isDisabled, setIsDisabled] = useState(false);
  const [likeClicked, setLikeClicked] = useState(false);
  const [dislikeClicked, setDislikeClicked] = useState(false);

  const handleLikeClick = () => {
    if(!isDisabled){
    setLikeClicked(!likeClicked);
    setDislikeClicked(false);
    setIsDisabled(true); 
    sendFeedback(likeClicked ? 0 : 1);
    }
    // console.log("liked clicked",likeClicked ? 0 : 1)
  };
  // console.log("fun render",likeClicked , dislikeClicked)

  const handleDislikeClick = () => {
    if(!isDisabled){
    setDislikeClicked(!dislikeClicked);
    // console.log("DisLiked clicked",dislikeClicked, likeClicked)
    setLikeClicked(false);
    setIsDisabled(true); 
    sendFeedback(dislikeClicked ? 0 : -1);
    }
    // console.log("Dsiliked clicked",dislikeClicked ? 0 : 1)
  };

  const sendFeedback = (feedback) => {
    sendUserLikeDislikeFeedback({
      sessionId: props.sessionDetails.session_id,
      userLikeDislike: feedback,
      response_type: JSON.stringify(props.message.type), 
      user_language: JSON.stringify(props.message.botType.language),
      response_data: props.message.text,
      user_like_dislike_timestamp: `${new Date().toLocaleString("en-GB", {
        hour12: true,
      })}`,
      user_query: props.message.previousQuery,
      // Add other props here
    });
  };

  return (
    <div className={classes.likeDislikeContainer} >
      <div className={`${classes.likeButton} icon-preview col s2 m3`} >
      {likeClicked ? (
          <ThumbUpAltIcon onClick={handleLikeClick} style={{ fontSize: 17, cursor: isDisabled ? "default" : "pointer" , fill: "rgb(20 193 40)" }} />
        ) : (
          <ThumbUpOutlinedIcon onClick={handleLikeClick}style={{ fontSize: 17, cursor: isDisabled ? "default" : "pointer"  }} />
        )}
      </div>
      <div
        className={`${classes.dislikeButton} icon-preview col s2 m3`}
       
      >
         {dislikeClicked ? (
          <ThumbDownAltIcon  onClick={handleDislikeClick} style={{ fontSize: 17, cursor: isDisabled ? "default" : "pointer" , fill: "#dd0707" }} />
        ) : (
          <ThumbDownOutlinedIcon   onClick={handleDislikeClick}style={{ fontSize: 17, cursor: isDisabled ? "default" : "pointer" }} />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    logInData: state.logInStatus,
    sessionDetails: state.sessionDetails,
    // Add other props here
  };
};

export default connect(mapStateToProps)(AdyaLikeDislikeButton);

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
// import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
// import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";
// import ThumbDownOutlinedIcon from "@material-ui/icons/ThumbDownOutlined";
// import "./AdyaLikeDislikeButton.css";
// import { sendUserLikeDislikeFeedback } from "../../../../services/indianbank_services/adya_feedback_services";
// import { connect } from "react-redux";

// /**
//  * Inline CSS => MUI4
//  * fontSize="large" || fontSize="small"
//  *
//  */

// const useStyles = makeStyles({
//   likeDislikeLabel: {
//     marginLeft: "7px",
//   },
// });

// function AdyaLikeDislikeButton(props) {
//   const classes = useStyles();
//   const [onLike, setonLike] = React.useState(false);
//   const [onDislike, setonDislike] = React.useState(false);
//   const [adyaLikeDislike, setonAdyaLikeDislike] = React.useState(0);
//   const [onClickCounter, setonClickCounter] = React.useState(0);
//   const [resData, setresData] = React.useState();

//   let response_data;
//   let user_query;

//   function sendAdyaQueryFeedback(adya_feedback) {
//     // console.log("adya_feedback: ", adya_feedback);

//     // console.log("props: ", props);
//     // console.log("JSON.stringify(props.message): ", JSON.stringify(props.message));

//     if (JSON.stringify(props.message.herocardData)) {
//       // console.log("herocard data is there: ", JSON.stringify(props.message.herocardData));
//       response_data = JSON.stringify(
//         props.message.herocardData.BODY.details.type
//       );
//       user_query = props.message.herocardData.BODY.details.data.title;
//       // console.log("User Query HEROCARD: ", user_query);
//       setresData(response_data);

//       // console.log("response_data: ", response_data);
//     } else if (JSON.stringify(props.message.workflowData)) {
//       // console.log("workflowData data is there: ", JSON.stringify(props.message.workflowData));
//       response_data = JSON.stringify(props.message.workflowData.BODY.type);
//       user_query = props.message.workflowData.BODY.type;
//       // console.log("User Query WORKFLOW: ", user_query);
//       setresData(response_data);
//       // console.log("response_data: ", response_data);
//     } else if (JSON.stringify(props.message.adyanlpData)) {
//       // console.log("nlp user_query: ", props.message.adyaNlpQuery)
//       // console.log("nlp data: ", JSON.stringify(props.message.adyanlpData.BODY));
//       user_query = props.message.adyaNlpQuery;
//       // console.log("User Query ADYA NLP: ", user_query);
//       response_data = JSON.stringify(props.message.adyanlpData.BODY);
//     }

//     // if(onClickCounter == 0){
//     //   setonClickCounter(1);
//     // } else if(onClickCounter == 1){
//     //   console.log("You already have clicked");
//     // }

//     if (adya_feedback == 1) {
//       setonLike(true);
//       // setonAdyaLikeDislike(adya_feedback);
//     } else if (adya_feedback == -1) {
//       setonDislike(true);
//       // setonAdyaLikeDislike(adya_feedback);
//     }
//   }

//   // function sendResponseData(data){
//   //   console.log("sendResponseData: ", data);

//   // }

//   return (
//     <>
//       <div
//         className="icon-preview col s2 m3"
//         onClick={() => {
//           sendAdyaQueryFeedback(1);
//           setonClickCounter(1);
//           setonAdyaLikeDislike(1);
//           sendUserLikeDislikeFeedback({
//             sessionId: props.sessionDetails.session_id,
//             userLikeDislike: 1,
//             user_query: user_query,
//             response_type: JSON.stringify(props.message.type),
//             user_language: JSON.stringify(props.message.botType.language),
//             response_data: response_data,
//             user_like_dislike_timestamp: `${new Date().toLocaleString("en-GB", {
//               hour12: true,
//             })}`,
//             // user_like_dislike_timestamp: `${new Date().toLocaleString("en-US", {
//             //   hour12: true,
//             // })}`,
//           });
//           // console.log(`Message: ${JSON.stringify(props.message)}`);
//         }}
//       >
//         {/* Thumbs Up Icon adya-like */}

//         {/* If true => Call Colored ThumbsUp Component */}
//         {onLike === true ? (
//           <ThumbUpAltIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         ) : (
//           <ThumbUpOutlinedIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         )}
//       </div>
//       <div
//         className="icon-preview col s2 m3"
//         onClick={() => {
//           sendAdyaQueryFeedback(-1);
//           setonClickCounter(1);
//           setonAdyaLikeDislike(1);
//           sendUserLikeDislikeFeedback({
//             sessionId: props.sessionDetails.session_id,
//             userLikeDislike: -1,
//             user_query: user_query,
//             response_type: JSON.stringify(props.message.type),
//             user_language: JSON.stringify(props.message.botType.language),
//             // response_data: JSON.stringify(props.message),
//             response_data: response_data,
//             user_like_dislike_timestamp: `${new Date().toLocaleString("en-GB", {
//               hour12: true,
//             })}`,
//             // user_like_dislike_timestamp: `${new Date().toLocaleString("en-US", {
//             //   hour12: true,
//             // })}`,
//           });
//           // console.log(`Message: ${JSON.stringify(props.message)}`);
//         }}
//       >
//         {/* Thumbs Down Icon adya-dislike */}
//         {/* <ThumbDownOutlinedIcon style={{ fontSize: 17, cursor: "pointer"}} /> */}

//         {/* If true => Call Colored ThumbsDown Component */}
//         {onDislike === true ? (
//           <ThumbDownAltIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         ) : (
//           <ThumbDownOutlinedIcon style={{ fontSize: 17, cursor: "pointer" }} />
//         )}
//       </div>
//     </>
//   );
// }

// const mapStateToProps = (state) => {
//   return {
//     logInData: state.logInStatus,
//     sessionDetails: state.sessionDetails,
//   };
// };

// export default connect(mapStateToProps)(AdyaLikeDislikeButton);
